import React from "react";
import "./About.css";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import video from "../../assets/videos/Agricolart-spot.mp4";
import poster from "../../assets/videos/poster.png";
import fullVideo from "../../assets/videos/Agricolart2020.m4v";

const About = ({content}) => {
    return (
        <section className="about">
            <h1>{content.title}</h1>
            <p>{content.text}</p>
            <video className="custom-video" poster={poster} controls>
                <source src={fullVideo} type="video/mp4"/>
                Your browser does not support the video tag.
            </video>
        </section>
    )
}

export default About;
